// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "client-viewer/" + ({"1798":"AdditionalDetails-AdditionalDetails","2029":"PlanStartDatePicker-PlanStartDatePicker"}[chunkId] || chunkId) + ".chunk.min.css";
};